import React from "react";
import styled from "styled-components";
import { useRef } from "react";
import { Portal } from "@mui/base";
import { Snackbar } from "@mui/material";
import toast from 'react-hot-toast';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;
  align-items: center;
  @media (max-width: 960px) {
    padding: 0px;
  }
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 1350px;
  padding: 0px 0px 80px 0px;
  gap: 12px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

const Title = styled.div`
  font-size: 42px;
  text-align: center;
  font-weight: 600;
  margin-top: 20px;
  color: ${({ theme }) => theme.text_primary};
  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 32px;
  }
`;

const Desc = styled.div`
  font-size: 18px;
  text-align: center;
  max-width: 600px;
  color: ${({ theme }) => theme.text_secondary};
  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 16px;
  }
  @media (max-width: 360px) {
    font-size: 14px;
    margin: 0 14px;
  }
`;

const ContactForm = styled.form`
  width: 95%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.card};
  padding: 32px;
  border-radius: 16px;
  box-shadow: rgba(23, 92, 230, 0.15) 0px 4px 24px;
  margin-top: 28px;
  gap: 12px;
  @media (max-width: 360px) {
    width: 92%;
  }
`;

const ContactTitle = styled.div`
  font-size: 18px;
  margin-bottom: 6px;
  font-weight: 500;
  color: ${({ theme }) => theme.text_primary};
`;

const ContactInput = styled.input`
  flex: 1;
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.text_secondary};
  outline: none;
  font-size: 18px;
  color: ${({ theme }) => theme.text_primary};
  border-radius: 12px;
  padding: 12px 16px;
  &:focus {
    border: 1px solid ${({ theme }) => theme.primary};
  }
  @media (max-width: 360px) {
    font-size: 14px;
    padding: 10px 16px;
  }
`;

const ContactInputMessage = styled.textarea`
  flex: 1;
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.text_secondary};
  outline: none;
  font-size: 18px;
  color: ${({ theme }) => theme.text_primary};
  border-radius: 12px;
  padding: 12px 16px;
  &:focus {
    border: 1px solid ${({ theme }) => theme.primary};
  }
  @media (max-width: 360px) {
    font-size: 14px;
  }
`;

const ContactButton = styled.input`
  width: 100%;
  text-decoration: none;
  text-align: center;
  background: hsla(271, 100%, 50%, 1);
  background: linear-gradient(
    225deg,
    hsla(271, 100%, 50%, 1) 0%,
    hsla(294, 100%, 50%, 1) 100%
  );
  background: -moz-linear-gradient(
    225deg,
    hsla(271, 100%, 50%, 1) 0%,
    hsla(294, 100%, 50%, 1) 100%
  );
  background: -webkit-linear-gradient(
    225deg,
    hsla(271, 100%, 50%, 1) 0%,
    hsla(294, 100%, 50%, 1) 100%
  );
  padding: 13px 16px;
  margin-top: 2px;
  border-radius: 12px;
  border: none;
  color: ${({ theme }) => theme.text_primary};
  font-size: 18px;
  font-weight: 600;
  
  @media (max-width: 360px) {
    margin-top: 10px;
    font-size: 14px;
  }
`;

const Contact = () => {
  //hooks
  const [disabled, setBtnDisable] = React.useState(false);
  const form = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (disabled) {
      return;
    }
    setBtnDisable(true);
    var email = e.target.email.value;
    var name = e.target.name.value;
    var subject = e.target.name.value;
    var message = e.target.name.value;
    var xhr = new XMLHttpRequest();
    xhr.open("POST", "https://iamnvn.in/api/msg.php", true);
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhr.withCredentials = false;

    xhr.send(
      `name=${name}&email=${email}&project=${subject}&message=${message}`
    );
    xhr.onload = function () {
      if (xhr.responseText == "1") {
        toast.success('Message sent Successfully!', {
          duration: 4000,
          position: 'bottom-center'
        });
        setBtnDisable(false);
        form.current.reset();
      } else {
        console.log(xhr.responseText);
      }
    };
  };

  return (
    <Container id="contact">
      <Wrapper>
        <Title>Contact</Title>
        <Desc>
          Feel free to reach out to me for any questions or opportunities!
        </Desc>
        <ContactForm ref={form} onSubmit={handleSubmit}>
          <ContactTitle>Contact Me</ContactTitle>
          <ContactInput placeholder="Name" name="name" required />
          <ContactInput placeholder="Email" name="email" required />
          <ContactInput placeholder="Subject" name="subject" required />
          <ContactInputMessage
            placeholder="Message"
            rows="4"
            name="message"

          />
          <ContactButton
            type="submit"
            value={disabled ? "Sending..." : "Send Message"}
            disabled={disabled}
          />
        </ContactForm>
      </Wrapper>
    </Container>
  );
};

export default Contact;
